import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { WebEntryLayout } from './entryHelpers';

export default function GoogleLoginPlaceholderScreen() {
  const navigate = useNavigate();

  return (
    <WebEntryLayout>
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '48px 28px 40px',
        fontFamily: T.font,
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <div style={{ fontSize: 22, fontWeight: 800, color: T.text, textAlign: 'center' }}>
        Google Sign-In
      </div>
      <div style={{ fontSize: 11, color: T.textSec, textAlign: 'center', marginTop: 6, marginBottom: 36 }}>
        Sign in with your Google account
      </div>

      {/* Placeholder icon */}
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: 24,
          background: '#6B728014',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 20,
        }}
      >
        <svg width={36} height={36} viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v8M8 12h8" />
        </svg>
      </div>

      {/* Status message */}
      <div
        style={{
          width: '100%',
          maxWidth: 340,
          padding: '16px 20px',
          borderRadius: 14,
          background: '#F9FAFB',
          border: `1px solid ${T.border}`,
          textAlign: 'center',
          marginBottom: 28,
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 700, color: '#6B7280', marginBottom: 6 }}>
          Google login integration pending
        </div>
        <div style={{ fontSize: 10, color: T.textSec, lineHeight: 1.6 }}>
          Google Sign-In will be available in a future update. Please use phone or email login for now.
        </div>
      </div>

      {/* Alternative actions */}
      <button
        onClick={() => navigate('/patient/login/phone')}
        style={{
          width: '100%',
          maxWidth: 340,
          padding: '14px 0',
          background: `linear-gradient(135deg, ${T.teal}, ${T.overlap})`,
          color: T.white,
          border: 'none',
          borderRadius: 14,
          fontSize: 14,
          fontWeight: 700,
          fontFamily: T.font,
          cursor: 'pointer',
          marginBottom: 10,
        }}
      >
        Continue with Phone
      </button>

      <button
        onClick={() => navigate('/patient/login/email')}
        style={{
          width: '100%',
          maxWidth: 340,
          padding: '14px 0',
          background: T.white,
          color: T.navy,
          border: `1.5px solid ${T.navy}`,
          borderRadius: 14,
          fontSize: 14,
          fontWeight: 700,
          fontFamily: T.font,
          cursor: 'pointer',
          marginBottom: 10,
        }}
      >
        Continue with Email
      </button>

      <div
        onClick={() => navigate('/patient/onboarding')}
        style={{ fontSize: 13, color: T.teal, fontWeight: 600, cursor: 'pointer', marginTop: 10 }}
      >
        Register new account
      </div>
    </div>
    </WebEntryLayout>
  );
}
